// extracted by mini-css-extract-plugin
export default {"root":"wwOfr","page":"ke39_"};